// Contract for GET /risk/results/breakdown (I360A-2701, as built on
// saas_risk_management 9ad456d, PR 75314). `weight` is the applied % of the axis,
// excluding the global axis weighting; `weightedPoints` is unrounded.

export type BreakdownFormat =
	| 'grade'
	| 'date'
	| 'distance'
	| 'count'
	| 'categorical'
	| 'number';

// 'deselected' (I360A-3651): switched off in the config and scored 0. Not a default
// (usedDefault is false) and not counted in data coverage.
export type DefaultReason = 'nullScore' | 'unmatched' | 'noData' | 'deselected';

export interface BreakdownComponent {
	name: string;
	value: string | number | null;
	unit: string | null;
	format: BreakdownFormat;
	score: number | null;
	weight: number;
	weightedPoints: number;
	usedDefault: boolean;
	defaultReason: DefaultReason | null;
	band: string | null;
}

export interface BreakdownCategory {
	category: string;
	percentage: number;
	appliedPercentage: number;
	components: BreakdownComponent[];
}

export interface BreakdownAxis {
	total: number | null;
	axisWeighting: number;
	categories: BreakdownCategory[];
}

export interface RiskBreakdown {
	LOF: BreakdownAxis;
	CoF: BreakdownAxis;
}

export interface RiskBreakdownResponse {
	assetId: string;
	configVersionId: string;
	breakdown: RiskBreakdown | null;
}

export interface RiskBreakdownEntry {
	status: 'loading' | 'loaded' | 'error';
	data?: RiskBreakdownResponse;
	/** The fetch this entry belongs to; responses for any other are dropped. */
	requestId?: number;
}

export type RiskBreakdownState = Record<string, RiskBreakdownEntry>;

export const riskBreakdownInitialState: RiskBreakdownState = {};

export const riskBreakdownKey = (configId: string, assetId: string): string =>
	`${configId}|${assetId}`;
